import { fetchPopularNotes, groupMovements } from '../../api/endpointsBackend';
import { getWorkspaceId } from '../../auth/workspaceService';
import { todayLocalISO } from '../../utils/localDate';

const TILE_WINDOW_DAYS = 90;

// What the session reads once per workspace: the popular notes and the most
// used categories of each type.
const session = { workspaceId: null, notes: null, tiles: {} };
function sessionCache() {
  const workspaceId = String(getWorkspaceId() ?? '');
  if (session.workspaceId !== workspaceId) {
    session.workspaceId = workspaceId;
    session.notes = null;
    session.tiles = {};
  }
  return session;
}

export function loadPopularNotes() {
  const cache = sessionCache();
  if (!cache.notes) {
    cache.notes = fetchPopularNotes().catch(() => {
      cache.notes = null;
      return [];
    });
  }
  return cache.notes;
}

/** Category ids of `type`, most used in the last 90 days first, counts summed across currencies. */
export function loadTopCategoryIds(type) {
  const cache = sessionCache();
  if (!cache.tiles[type]) {
    const now = new Date();
    const start = todayLocalISO(new Date(now.getFullYear(), now.getMonth(), now.getDate() - TILE_WINDOW_DAYS));
    cache.tiles[type] = groupMovements(
      [{ entity: 'Movement', column: 'type', operator: 'in', values: [type] }],
      ['currency', 'category_id'],
      start,
    ).then((rows) => {
      const counts = new Map();
      (rows || []).forEach((row) => {
        if (row.category_id == null) return;
        counts.set(row.category_id, (counts.get(row.category_id) || 0) + (row.num_movements || 0));
      });
      return [...counts.entries()].sort((a, b) => b[1] - a[1]).map(([id]) => id);
    }).catch(() => {
      delete cache.tiles[type];
      return [];
    });
  }
  return cache.tiles[type];
}
